import { render } from "./edit-tax.vue?vue&type=template&id=2f4d43a8"
import script from "./edit-tax.vue?vue&type=script&lang=js"
export * from "./edit-tax.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__